module.exports = __webpack_public_path__ + "static/media/19_l_holst_4.84_60.93.6fcf66b1.png";